'use client';

import { formatText, TextRole } from '@pickleballinc/lib/format-text';
import {
  Dialog,
  DialogActionButton,
  DialogBody,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogSubTitle,
  DialogTitle,
} from '@pickleballinc/ui/components/ui/dialog-v2';

const TITLE_PREFIX = formatText({ text: 'Brag about', role: TextRole.ModalTitle });
const TITLE_FALLBACK = formatText({
  text: 'Show off this achievement?',
  role: TextRole.ModalTitle,
});
const SUBTITLE = formatText({
  text: 'Send a brag notification to your friends',
  role: TextRole.DescriptiveText,
});
const BODY_PREFIX = formatText({
  text: "We'll send a notification to all your friends letting them know you earned",
  role: TextRole.DescriptiveText,
});
const BODY_FALLBACK_SUBJECT = 'this';
const COOLDOWN_NOTE = formatText({
  text: 'You can brag about each achievement once every 7 days.',
  role: TextRole.DescriptiveText,
});
const CANCEL_LABEL = formatText({ text: 'Cancel', role: TextRole.ButtonLabel });
const SENDING_LABEL = formatText({ text: 'Sending...', role: TextRole.ButtonLabel });
const SEND_LABEL = formatText({ text: 'Send brag', role: TextRole.ButtonLabel });

interface BragConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
  achievementName?: string;
}

export function BragConfirmModal({
  open,
  onOpenChange,
  onConfirm,
  isPending,
  achievementName,
}: BragConfirmModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='!max-w-[420px]'>
        <DialogHeader>
          <DialogTitle>
            {achievementName ? `${TITLE_PREFIX} ${achievementName}?` : TITLE_FALLBACK}
          </DialogTitle>
          <DialogSubTitle className='sr-only'>{SUBTITLE}</DialogSubTitle>
        </DialogHeader>
        <DialogBody className='my-0 gap-3'>
          <p className='text-sm text-gray-900'>
            {`${BODY_PREFIX} `}
            {achievementName ? (
              <span className='font-semibold'>{achievementName}</span>
            ) : (
              BODY_FALLBACK_SUBJECT
            )}
            {`. 🎉`}
          </p>
          <p className='text-xs text-gray-500'>{COOLDOWN_NOTE}</p>
        </DialogBody>
        <DialogFooter>
          <DialogCloseButton>{CANCEL_LABEL}</DialogCloseButton>
          <DialogActionButton onClick={onConfirm} disabled={isPending}>
            {isPending ? SENDING_LABEL : SEND_LABEL}
          </DialogActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
